import { Box, Grid, Title, WizardStepRenderParams } from '@factorialco/deprecated-design-system'
import {
  CurrencySelectorCurrencyFragment,
  PurchaseOrderModalLegalEntityFragment,
} from 'generated/resources/graphql'

import MoneyField from 'modules/core/components/MoneyField'
import SelectField from 'modules/core/components/SelectField'
import TextField from 'modules/core/components/TextField'
import { fromCents } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'

import CurrencySelector from 'modules/finance/components/CurrencySelector'
import type { WizardData } from 'modules/procurement/components/purchaseOrders/UpdateOrderModal/types'

interface Props {
  currencies: CurrencySelectorCurrencyFragment[]
  legalEntities: PurchaseOrderModalLegalEntityFragment[]
}

const CostStep: React.FC<WizardStepRenderParams<WizardData> & Props> = ({
  data,
  onDataChanged,
  currencies,
  legalEntities,
}) => {
  return (
    <Box gap="s24">
      <Title
        description={i18n.t(
          'procurement.purchase_orders.update_order_wizard.steps.cost.description'
        )}
        title={i18n.t('procurement.purchase_orders.update_order_wizard.steps.cost.title')}
      />
      <Box gap="s24" paddingRight="s24">
        <Grid variant="fixed">
          <Box gridColSpan={{ xxs: 4 }}>
            <MoneyField
              label={i18n.t(
                'procurement.purchase_orders.update_order_wizard.steps.cost.fields.requested_amount'
              )}
              readonly
              currency={data.purchaseRequestCost.currency}
              value={String(fromCents(data.purchaseRequestCost.cents))}
            />
          </Box>
          <Box flexDirection="row" alignItems="flexEnd" gap="s4" gridColSpan={{ xxs: 6 }}>
            <Box gridColSpan={{ xxs: 4 }}>
              <TextField
                mandatory
                type="number"
                value={(data.purchaseOrderCost.cents
                  ? data.purchaseOrderCost.cents / 100
                  : ''
                ).toString()}
                label={i18n.t(
                  'procurement.purchase_orders.update_order_wizard.steps.cost.fields.purchase_amount'
                )}
                onChange={(value) =>
                  onDataChanged({
                    ...data,
                    purchaseOrderCost: { ...data.purchaseOrderCost, cents: Number(value) * 100 },
                  })
                }
              />
            </Box>
            <Box minWidth="s96">
              <CurrencySelector
                label=""
                defaultValue={data.purchaseOrderCost.currency}
                currencies={currencies}
                onChange={(value) =>
                  onDataChanged({
                    ...data,
                    purchaseOrderCost: { ...data.purchaseOrderCost, currency: value },
                  })
                }
              />
            </Box>
          </Box>
        </Grid>
        <SelectField
          mandatory
          value={data.legalEntityId.toString()}
          label={i18n.t(
            'procurement.purchase_orders.update_order_wizard.steps.cost.fields.legal_entity'
          )}
          onChange={(value) => {
            onDataChanged({ ...data, legalEntityId: parseInt(value) })
          }}
          options={legalEntities.map((option) => ({
            value: option.id,
            label: option.legalName,
          }))}
        />
      </Box>
    </Box>
  )
}

export default CostStep
